export default class Throttle {
  static execute(timestamp, wait, fn) {
    if ((timestamp + wait - Date.now()) < 0) {
      fn()
      return Date.now();
    }
    return timestamp;
  }
}
